/**
 * The ESG pillars a module tag can sit under, as riu_keywords.esg_pillar stores them.
 * @type {{ value: string, label: string, short: string }[]}
 */
export const ESG_PILLARS = [
  { value: "ENVIRONMENT", label: "Environment", short: "E" },
  { value: "SOCIAL", label: "Social", short: "S" },
  { value: "GOVERNANCE", label: "Governance", short: "G" },
];

/**
 * @param {string|null|undefined} text A tag key or value.
 * @returns {string} The text lower-cased with whitespace removed, as the tag filters compare tags.
 */
export const normalizeTagText = (text) => String(text ?? "").toLowerCase().replace(/\s+/g, "");

/**
 * @param {string|null|undefined} keywordType A riu_keywords keyword_type or a tag key.
 * @returns {boolean} Whether it names the module tag key, in any case or spacing.
 */
export const isModuleKeyword = (keywordType) => normalizeTagText(keywordType) === "module";

/**
 * @param {string|null|undefined} pillar A stored pillar.
 * @returns {{ value: string, label: string, short: string }|undefined} Its option.
 */
export const pillarOption = (pillar) => ESG_PILLARS.find((option) => option.value === pillar);

/**
 * Each module tag's pillar, keyed by its normalized text. A spelling with no pillar never hides one another
 * spelling of the same tag has.
 * @param {{ keyword_type: string, keyword_value: string, esg_pillar?: string|null }[]} keywords riu_keywords rows.
 * @returns {Record<string, string>} Pillar by normalized module tag.
 */
export const modulePillarsOf = (keywords) => {
  const pillars = {};
  keywords.forEach((keyword) => {
    if (!isModuleKeyword(keyword.keyword_type) || !keyword.esg_pillar) return;
    pillars[normalizeTagText(keyword.keyword_value)] = keyword.esg_pillar;
  });
  return pillars;
};
